import {
  GET_TAGS,
  GET_TAGS_SUCCESS,
  GET_TAGS_ERROR,
  ADD_TAG,
  ADD_TAG_SUCCESS,
  ADD_TAG_ERROR,
  REMOVE_TAG,
  REMOVE_TAG_ERROR,
  REMOVE_TAG_SUCCESS
} from '../actions';

/* ADD */
export const addTag = (tag, history) => ({
  type: ADD_TAG,
  payload: { tag, history }
})
export const addTagSuccess = (tag) => ({
  type: ADD_TAG_SUCCESS,
  payload: tag
})
export const addTagError = (message) => ({
  type: ADD_TAG_ERROR,
  payload: { message }
})

/* GET */
export const getTags = (user, history) => ({
  type: GET_TAGS,
  payload: { user, history }
});
export const getTagsSuccess = (user) => ({
  type: GET_TAGS_SUCCESS,
  payload: user
});
export const getTagsError = (message) => ({
  type: GET_TAGS_ERROR,
  payload: { message }
});

/* REMOVE */
export const removeTag = (tag,history) => ({
  type: REMOVE_TAG,
  payload: { tag,history }
});
export const removeTagSuccess = () => ({
  type: REMOVE_TAG_SUCCESS,
  payload: {}
});
export const removeTagError = (message) => ({
  type: REMOVE_TAG_ERROR,
  payload: { message }
});

